<template>
	<section class="sk-simple">
		<div class="sk-simple__wrapper">
			<div class="sk-simple__panel">
				<aside class="sk-simple__highlight">
					<img class="sk-simple__highlight-logo" src="/static/svg/logos/logo-white.svg" alt="Idicare Logo">
					<div class="sk-simple__highlight-title">Health Aid Technologies</div>
					<div class="sk-simple__highlight-subtitle">We care about your health</div>
				</aside>
				<main class="sk-simple__content">
					<router-view id="content"/>
				</main>
			</div>
		</div>
	</section>
</template>

<script>
export default {
	name: 'app-simple-shell'
}
</script>

<style scope>

.sk-simple {
	width: 100vw;
	height: 100vh;
	display: grid;
	align-items: center;
	justify-items: center;
	background: linear-gradient(45deg, #dff7f9, #72bdc1);
	overflow-y: auto;
}

.sk-simple__wrapper {
	padding: 10px;
	max-height: 600px;
	height: 100%;
	width: 100%;
	max-width: calc(480px * 2);
}

.sk-simple__panel {
	display: grid;
	grid-template-columns: 1fr 1fr;
	height: 100%;
	background-color: #fff;
	box-shadow: rgba(0,0,0,0.1) 0 0 12px;
	border-radius: 3px;
	overflow: hidden;
}

.sk-simple__highlight {
	max-width: 480px;
	width: 100%;
	background: linear-gradient(-180deg, #00aeb9, #00a2ac);
	display: flex;
	align-items: center;
	justify-content: center;
	flex-direction: column;
	padding: 40px;
}

.sk-simple__highlight-logo {
	height: 200px;
}

.sk-simple__highlight-title {
	font-size: 18px;
	text-transform: uppercase;
	color: #fff;
	padding: 20px 0 10px 0;
}

.sk-simple__highlight-subtitle {
	font-size: 18px;
	color: #fff;
}

.sk-simple__content {
	max-width: 480px;
	width: 100%;
	padding: 40px;
	overflow-y: auto;
}

@media screen and (max-width: 1024px) {
	.sk-simple__wrapper {
		max-height: 100%;
		height: fit-content;
		width: 100%;
		max-width: 480px;
	}

	.sk-simple__highlight {
		background-size: 100px;
	}

	.sk-simple__highlight-logo {
		height: 100px;
	}

	.sk-simple__highlight-title {}

	.sk-simple__highlight-subtitle {}

	.sk-simple__panel {
		grid-template-columns: 1fr;
		grid-template-rows: 200px 1fr;
	}

	.sk-simple__content {
		min-height: fit-content;
		padding: 25px;
	}
}

</style>



// WEBPACK FOOTER //
// src/modules/shell/AppSimpleShell.vue